// Composables
import GuestLayout from "@/layouts/GuestLayout.vue";
import CodeGuestView from "@/views/CodeGuestView.vue";
import LoginView from "@/views/LoginView.vue";
import ResetLinkView from "@/views/ResetLinkView.vue";
import ResetPasswordGuestView from "@/views/ResetPasswordGuestView.vue";

export default [
  {
    path: "/",
    component: GuestLayout,
    children: [
      {
        path: "login",
        name: "login",
        component: LoginView,
      },
      {
        path: "/reset-password-guest",
        name: "reset-password-guest",
        component: ResetPasswordGuestView,
      },
      {
        path: "/code",
        name: "code",
        component: CodeGuestView,
      },
      {
        path: "reset-password-link/:token",
        name: "reset-password-link",
        component: ResetLinkView,
      },
    ],
  },
];
